import { IResponse } from '@alycecom/services';
import { createAsyncAction } from '@alycecom/utils';

import { TBookedMeetingInfoResponse } from './bookedMeetingInfo.types';

const prefix = 'RECIPIENT/BOOKED_MEETING_INFO';

export const fetchBookedMeetingInfo = createAsyncAction<
  string,
  IResponse<TBookedMeetingInfoResponse | null> & { hasIntegration: boolean },
  void
>(`${prefix}/FETCH_BOOKED_MEETING_INFO`);
